var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%","background":"#fff","margin":"10px"}},[_c('h1',{staticClass:"fontL"},[_vm._v(_vm._s(_vm.titleName?_vm.titleName:'')+"信息管理系统")]),_vm._v(" "),_c('h1',{staticClass:"fontR"},[_vm._v(_vm._s(_vm.date))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-183b0512","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/defaultPage/defaultPage.vue
// module id = null
// module chunks = 